import React from 'react';

import {Icon, Text} from '@albert-io/atomic';

interface Props {
  /** Heading; defaults to "No results found". */
  title?: string;
  /** Body copy; defaults to the standard "try searching again" message. */
  description?: string;
}

/**
 * Shared empty state for when a search/filter matches nothing: a magnifying-glass bubble +
 * heading + body, centered. Used by the v2 assignments and folders lists, and reusable anywhere
 * a search or filter yields no results.
 */
export const NoSearchResults = ({
  title = 'No results found',
  description = "We couldn't find what you searched for. Try searching again."
}: Props) => (
  <div className='flex w-full flex-col items-center gap-x3 py-x8 text-center'>
    <div
      aria-hidden='true'
      className='flex h-x8 w-x8 items-center justify-center rounded-full background-subtle'
    >
      <Icon className='text-xxl' color='tertiary' icon='magnifying-glass' iconStyle='regular' />
    </div>
    <div className='flex flex-col gap-x1'>
      <Text as='div' size='l'>
        {title}
      </Text>
      <Text as='div' className='max-w-[440px]' color='tertiary' size='m'>
        {description}
      </Text>
    </div>
  </div>
);
